const manifestos = [
  {
    label: 'Conservative',
    value: 'Conservatives',
    image: 'conservative',
    hash: 'conservative',
    selectable: true,
    link: 'https://manifesto.conservatives.com/',
    default: true,
  },
  {
    label: 'Labour',
    image: 'labour',
    hash: 'labour',
    value: 'Labour',
    link: 'https://labour.org.uk/change/',
    selectable: true,
    default: true,
  },
  {
    label: 'Lib Dem',
    value: 'LiberalDemocrats',
    image: 'libdem',
    hash: 'lib-dem',
    selectable: true,
    link: 'https://www.libdems.org.uk/manifesto',
    default: true,
  },
  {
    label: 'Reform UK',
    image: 'reformuk',
    hash: 'reform-uk',
    value: 'Reform',
    selectable: true,
    link: 'https://www.reformparty.uk/policies',
  },
  {
    label: 'SNP',
    image: 'snp',
    hash: 'snp',
    value: 'SNP',
    selectable: true,
    link: 'https://www.snp.org/manifesto',
  },
  {
    label: 'Plaid Cymru',
    image: 'plaidcymru',
    hash: 'plaid-cymru',
    value: 'PlaidCymru',
    selectable: true,
    link: 'https://www.partyof.wales/manifesto',
  },
  {
    label: 'Green Party',
    image: 'greenparty',
    hash: 'green-party',
    value: 'GreenParty',
    link: 'https://greenparty.org.uk/about/our-manifesto/',
    selectable: true,
  },
];

const manifestos2026 = {
  holyrood: [
    {
      label: 'Scottish National Party',
      image: 'scottishnationalparty',
      hash: 'scottish-national-party',
      value: 'SNP',
      selectable: true,
      color: '#0E5AA7',
      link: 'https://www.snp.org/manifesto/ ',
      default: true,
    },
    {
      label: 'Scottish Labour',
      image: 'scottishlabour',
      hash: 'scottish-labour',
      value: 'ScottishLabour',
      selectable: true,
      color: '#d05e17',
      link: 'https://scottishlabour.org.uk/manifesto-2026/',
      default: true,
    },
    {
      label: 'Scottish Conservative',
      image: 'scottishconservative',
      hash: 'scottish-conservative',
      value: 'ScottishConservative',
      selectable: true,
      color: '#0E5AA7',
      link: 'https://www.scottishconservatives.com/manifestos/2026-scottish-parliament-election-manifesto',
      default: true,
    },
    {
      label: 'Reform UK Scotland',
      image: 'reformukscotland',
      hash: 'reform-uk-scotland',
      value: 'ReformScotland',
      selectable: true,
      color: '#0094CC',
      link: 'https://www.reformparty.uk/view-pdf/scotland-manifesto',
      default: true,
    },

    {
      label: 'Scottish Liberal Democrats',
      image: 'scottishlibdem',
      hash: 'scottish-liberal-democrats',
      value: 'ScottishLiberalDemocrats',
      selectable: true,
      color: '#FFD700',
      link: 'https://www.scotlibdems.org.uk/2026-manifesto',
      default: true,
    },
    {
      label: 'Scottish Green Party',
      image: 'scottishgreenparty',
      hash: 'scottish-green-party',
      value: 'ScottishGreenParty',
      selectable: true,
      color: '#65A130',
      link: 'https://greens.scot/manifesto',
      default: true,
    },
  ],
  senedd: [
    {
      label: 'Welsh Labour',
      image: 'welshlabour',
      hash: 'welsh-labour',
      value: 'WelshLabour',
      selectable: true,
      color: '#B81C2A',
      link: 'https://www.welshlabour.wales/manifesto-2026',
      default: true,
    },
    {
      label: 'Plaid Cymru',
      image: 'plaidcymru',
      hash: 'plaid-cymru',
      value: 'PlaidCymru',
      selectable: true,
      color: '#3F8428',
      link: 'https://www.partyof.wales/manifesto',
      default: true,
    },
    {
      label: 'Reform UK Wales',
      image: 'reformukwales',
      hash: 'reform-uk-wales',
      value: 'ReformWales',
      selectable: true,
      color: '#0094CC',
      link: 'https://www.reformparty.uk/view-pdf/welsh-manifesto',
      default: true,
    },
    {
      label: 'Wales Green Party',
      image: 'walesgreenparty',
      hash: 'wales-green-party',
      value: 'WalesGreenParty',
      selectable: true,
      color: '#65A130',
      link: 'https://wales.greenparty.org.uk/manifesto/',
    },
    {
      label: 'Welsh Conservative',
      image: 'welshconservative',
      hash: 'welsh-conservative',
      value: 'WelshConservative',
      selectable: true,
      color: '#0E5AA7',
      link: 'https://www.conservatives.wales/ourplan',
    },
    {
      label: 'Welsh Liberal Democrats',
      image: 'welshlibdem',
      hash: 'welsh-lib-dem',
      value: 'WelshLiberalDemocrats',
      selectable: true,
      color: '#FFD700',
      link: 'https://www.libdems.wales/manifesto-2026',
    },
  ],
};
export { manifestos2026, manifestos };
